import FasesSection from '../../sections/FasesSection';
import Descargas from '../../components/Descargas';
import { DocumentRepository2 } from '../../components/DocumentRepository';
import { motion, AnimatePresence } from "framer-motion";
import { FaFilePdf, FaProjectDiagram, FaLightbulb, FaClipboardList, FaMap } from "react-icons/fa";

import './Costalegre.css';
import React, { useState, useEffect } from 'react';
import { 
  ChevronRight,
  Users,
  Map,
  Landmark,
  Calendar,
  MountainSnow,
  MapPin,
  Waves,
  Info,
  FileSignature,
  FileSpreadsheet,
  BarChart3,
  Zap,
  FileText,
  ArrowDown,
  Compass,
  GlobeIcon,
  DownloadCloud,
  CheckCircle,
  ExternalLink,
  Layers,
  Target,
} from 'lucide-react';

import AboutSection from '../../sections/AboutSection';
import VisorSection from '../../sections/VisorSection';
import BitacoraSection from '../../sections/BitacoraSection';

import Gallery from '../../sections/Gallery';

import Hero from '../../components/Hero';


import { useLocation } from 'react-router-dom';






// Componente para mostrar un dato como un 'Badge'
const DetailBadge = ({ icon: Icon, label, value }) => (
  <div className="flex items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-xl transition-all hover:bg-teal-100 dark:hover:bg-teal-900/30">
    <Icon className="text-teal-600 dark:text-teal-400 mr-3 flex-shrink-0" size={20} />
    <div className="text-sm">
      <span className="font-semibold text-gray-700 dark:text-gray-300 block leading-tight">{label}:</span>
      <span className="text-gray-900 dark:text-white font-bold">{value}</span>
    </div>
  </div>
);

const StatusBadge = () => {
  return (
    <motion.div 
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-teal-500/20 \
        backdrop-blur-md border border-emerald-500/30"
    >
      <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse mr-2" />
      <span className="text-sm font-medium text-white tracking-wider">FASE </span>
      <div className="ml-2 pl-2 border-l border-white/20">
        <span className="text-xs text-white/70">En Ejecución</span>
      </div>
    </motion.div>
  );
};

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const offset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};
const ModernBanner = ({ onScrollClick }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const stats = [
    { value: "4", label: "Municipios", icon: MapPin },
    { value: "7,385", label: "km²", icon: Map },
    { value: "2019", label: "Inicio", icon: Calendar },
    { value: "Vigente", label: "Estado", icon: CheckCircle },
  ];

  return (
    <>
      <section className="relative h-screen min-h-[800px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="images/Foto-Costa.jpeg"
            alt="Paisaje Región Costalegre"
            className="w-full h-full object-cover"
            style={{
              transform: `translate(${mousePosition.x * 0.01}px, ${mousePosition.y * 0.01}px)`,
              transition: 'transform 0.1s ease-out'
            }}
          />
          
          <div className="absolute inset-0 bg-gradient-to-br from-gray-900/70 via-gray-900/60 to-gray-900/50" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 via-transparent to-gray-900/10" />
          
          <div 
            className="absolute top-1/4 left-1/4 w-64 h-64 bg-gradient-to-r from-cyan-500/5 to-emerald-500/5 rounded-full blur-3xl"
            style={{
              transform: `translate(${mousePosition.x * 0.02}px, ${mousePosition.y * 0.02}px)`
            }}
          />
        </div>

        <div className="relative z-10 h-full flex items-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto w-full">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="space-y-8"
              >
                <StatusBadge />

                <div className="space-y-4">
                  <h1 className="text-4xl md:text-5xl font-light text-white leading-tight">
                    Región
                    <br />
                    <span className="font-bold bg-gradient-to-r from-cyan-400 via-emerald-400 to-lime-400 bg-clip-text text-transparent">
                      Costalegre
                    </span>
                  </h1>
                  
                  <div className="flex items-center gap-3 text-white/90">
                    <div className="h-px w-12 bg-gradient-to-r from-cyan-400 to-transparent" />
                    <span className="text-lg font-light tracking-wide">
                      Ordenamiento Ecológico Territorial· Regional
                    </span>
                  </div>
                </div>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="text-white/80 text-base leading-relaxed max-w-md font-light"
                >
                  Una región costera estratégica con playas, manglares, esteros y comunidades ligadas a la pesca y la agricultura. 
                  El ordenamiento busca equilibrar la protección ambiental con el desarrollo social y económico.
                </motion.p>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                  className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-6 border-t border-white/20"
                >
                  {stats.map((stat, index) => {
                    return (
                      <div key={index} className="text-center">
                        <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
                        <div className="text-xs text-white/70 tracking-wide">{stat.label}</div>
                      </div>
                    );
                  })}
                </motion.div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="space-y-6"
              >
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  className="bg-white/15 backdrop-blur-md rounded-2xl p-8 border border-white/30"
                >
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-gradient-to-br from-cyan-500 to-emerald-500 rounded-xl">
                      <Compass className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white">Explorar Programa</h3>
                      <p className="text-sm text-white/80">Acceso completo a recursos</p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <button 
                      onClick={() => onScrollClick('DocumentosE')}
                      className="w-full px-6 py-4 bg-gradient-to-r from-cyan-600 to-emerald-600 
                        text-white rounded-xl hover:shadow-xl transition-all duration-300
                        flex items-center justify-center gap-3 font-medium group"
                    >
                      <FileText className="w-5 h-5" />
                      Documentos Especiales
                      <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </button>
                    
                    <button 
                      onClick={() => onScrollClick('visor-completo')}
                      className="w-full px-6 py-4 bg-white/20 backdrop-blur-md border border-white/30
                        text-white rounded-xl hover:bg-white/30 transition-all duration-300
                        flex items-center justify-center gap-3 font-medium"
                    >
                      <GlobeIcon className="w-5 h-5" />
                      Visor GIS Completo
                    </button>
                    
                    <button 
                      onClick={() => onScrollClick('Descargas')}
                      className="w-full px-6 py-4 bg-white/10 backdrop-blur-md border border-white/20
                        text-white rounded-xl hover:bg-white/20 transition-all duration-300
                        flex items-center justify-center gap-3 font-medium"
                    >
                      <DownloadCloud className="w-5 h-5" />
                      Recursos Especializados
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <button 
            onClick={() => onScrollClick('introduccion')}
            className="group flex flex-col items-center"
          >
            <span className="text-xs text-white/80 mb-2 tracking-widest font-light">
              EXPLORAR
            </span>
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
              className="p-2 bg-white/20 backdrop-blur-md rounded-full border border-white/30
                group-hover:bg-white/30 transition-all"
            >
              <ArrowDown className="w-5 h-5 text-white" />
            </motion.div>
          </button>
        </motion.div>
      </section>
    </>
  );
};

const FullWidthVisorWithSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');

  return (
    <section id="visor-completo" className="py-16">
      <div className="max-w-[2000px] mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-cyan-600 to-emerald-600 bg-clip-text text-transparent">
              Plataforma Geoespacial Completa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Sistema de información geográfica integrado con documentación técnica completa para la región Costalegre.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            className={`lg:w-96 ${sidebarOpen ? 'block' : 'hidden lg:block'}`}
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-100 dark:border-gray-700 sticky top-6">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden mb-4 w-full p-2 bg-gradient-to-r from-cyan-500 to-emerald-500 text-white rounded-lg flex items-center justify-center gap-2"
              >
                {sidebarOpen ? 'Ocultar Panel' : 'Mostrar Panel'}
                <ChevronRight className={`w-4 h-4 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
              </button>

              <div className="flex mb-6 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <button
                  onClick={() => setActiveTab('uga')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'uga'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Clasificación UGA
                </button>
                <button
                  onClick={() => setActiveTab('descripcion')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'descripcion'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Descripción UGA
                </button>
                <button
                  onClick={() => setActiveTab('politica')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'politica'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Política Ambiental
                </button>
              </div>

              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="space-y-6"
                >
                  {activeTab === 'uga' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Layers className="w-5 h-5 text-blue-500 mr-2" />
                          Clasificación de UGAs
                        </h3>
                        <img
                          src="/images/Clave de UGA - COSTALEGRE.png"
                          alt="Clasificación de Unidades de Gestión Ambiental"
                          className="w-full h-auto rounded-lg shadow-md mb-4"
                        />
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                          Mapa de clasificación de las Unidades de Gestión Ambiental (UGAs) de la región Costalegre.
                        </p>
                      </div>
                    </>
                  )}

                  {activeTab === 'descripcion' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Info className="w-5 h-5 text-teal-500 mr-2" />
                          Descripción de las UGAs
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          Las Unidades de Gestión Ambiental son la unidad mínima del territorio a la que se asignan lineamientos y estrategias ecológicas para su manejo específico.
                        </p>
                        <div className="space-y-4">
                          <div className="bg-gradient-to-r from-cyan-50 to-emerald-50 dark:from-cyan-900/20 dark:to-emerald-900/20 rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Características</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Unidad territorial homogénea</li>
                              <li>• Criterios específicos de manejo</li>
                              <li>• Estrategias ecológicas definidas</li>
                              <li>• Monitoreo individualizado</li>
                            </ul>
                          </div>
                          <div className="bg-gradient-to-r from-emerald-50 to-lime-50 dark:from-emerald-900/20 dark:to-lime-900/20 rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Objetivos</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Gestión ambiental específica</li>
                              <li>• Aplicación de lineamientos</li>
                              <li>• Evaluación de resultados</li>
                              <li>• Adaptación de estrategias</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === 'politica' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Target className="w-5 h-5 text-purple-500 mr-2" />
                          Política Ambiental
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          El modelo de ordenamiento considera una zonificación integrada por políticas orientadas a la conservación, el uso responsable y la restauración del territorio.
                        </p>
                      </div>
                    </>
                  )}
                </motion.div>
              </AnimatePresence>
            </div>
          </motion.div>

          <div className="flex-1">
            <div className="bg-white dark:bg-gray-900/90 rounded-3xl shadow-2xl overflow-hidden border border-gray-200 dark:border-gray-700">
              <iframe
                title="Visor Costalegre"
                src="https://siga.jalisco.gob.mx/ordenamiento/visores/visorCostalegre/index.html"
                className="w-full min-h-[720px]"
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ModernBitacoraSection = ({ items }) => {
  const [expandedSection, setExpandedSection] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Bitácora del Programa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Registro documental completo del proceso de ordenamiento ecológico
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.button
                key={index}
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`p-6 rounded-2xl transition-all duration-300 text-left ${
                  expandedSection === index
                    ? `bg-gradient-to-br ${item.color} text-white shadow-2xl`
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-xl ${
                    expandedSection === index
                      ? 'bg-white/20'
                      : `bg-gradient-to-br ${item.color}`
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                </div>
                <p className={`text-sm ${
                  expandedSection === index ? 'text-white/90' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {expandedSection === index ? 'Ver documentos ↓' : 'Ver documentos →'}
                </p>
              </motion.button>
            );
          })}
        </div>

        {/* Contenido expandido */}
        <AnimatePresence>
          {expandedSection !== null && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
                {items[expandedSection].content.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-8 last:mb-0">
                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
                      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full mr-3" />
                      {section.subtitle}
                    </h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      {section.items.map((doc, docIndex) => (
                        <a
                          key={docIndex}
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-teal-50 
                            dark:hover:from-blue-900/20 dark:hover:to-teal-900/20 transition-all duration-300"
                        >
                          <div className="flex items-center gap-3">
                            <FileText className="w-5 h-5 text-blue-500 group-hover:text-teal-500 transition-colors" />
                            <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                              {doc.text}
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
                
                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {items[expandedSection].content.reduce((total, section) => total + section.items.length, 0)} documentos disponibles
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

const items = [
  {
    title: "Archivos Vectoriales",
    description: "Archivos geoespaciales para la consulta SIG.",
    imageUrl: "images/vectoriales.png",
    baseColor: "sky",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Descargas/VectorialesCostalegre.zip",
    target: "_blank"
  },
  {
    title: "Fichas UGAs",
    description: "Información detallada de cada Unidad de Gestión Ambiental (UGA).",
    imageUrl: "images/fichas_uga.png",
    baseColor: "green",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Costalegre.pdf",
    target: "_blank"
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
    imageUrl: "images/criterios.png",
    baseColor: "orange",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Descargas/Criterios%20Regi%C3%B3n%20Costalegre.pdf",
    target: "_blank"
  },
  {
    title: "Estrategias Ambientales",
    description: "Proyectos de orientación para la protección del entorno natural.",
    imageUrl: "images/estrategias.png",
    baseColor: "red",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Descargas/Estrategias%20Regi%C3%B3n%20Costalegre.pdf",
    target: "_blank"
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    imageUrl: "images/lineamientos.png",
    baseColor: "indigo",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Costalegre.pdf",
    target: "_blank"
  },
  // {
  //   title: "Mapa Interactivo",
  //   description: "Visualiza toda la información SIG directamente en el navegador.",
  //   imageUrl: "https://placehold.co/64x64/0d9488/ffffff?text=COMPASS",
  //   baseColor: "teal",
  //   link: "https://siga.jalisco.gob.mx/ordenamiento/mapa/index.html?capa=costalegre",
  //   target: "_blank"
  // }
];

const CostalegreMain = items.map((item) => ({
  id: item.title,
  title: item.title,
  subtitle: item.description,
  category: 'Descargas Costalegre',
  url: item.link,
}));



// Datos de los municipios
const municipalities = [
  {
    id: 1,
    name: 'Cabo Corrientes',
    shield: 'images/cabo-corrientes-escudo.png',
    description: 'Destacado por la pesca artesanal, agricultura de temporal y turismo de naturaleza, se ubica en zonas costeras con playas vírgenes, manglares y sierras con bosque tropical. Sus áreas naturales permiten la observación de fauna marina y terrestre.',
    population: '10,940 habitantes',
    area: '1543.4 km²',
    foundation: '1944',
    attractions: 'Playas como Yelapa, Mayto y Tehuamixtle, junto con caletas y miradores naturales como El Faro, conforman paisajes costeros ideales para el senderismo, recorridos en embarcación y la observación marina. Destacan la pesca artesanal y la gastronomía local.',
    color: 'from-blue-500 to-teal-600',
    EcologicaZona: 'Área Natural Protegida Área Estatal de Protección Hidrológica Sierra El Cuale y Santuario Playa Mismaloya.',
    administrativeRegion: 'Región Costa-Sierra Occidental',
    NumerodeUgas: '39'
  },
  {
    id: 2,
    name: 'Tomatlán',
    shield: 'images/tomatlan-escudo.png',
    description: 'Con agricultura, pesca y ganadería, se ubica en lomeríos y playas con ríos y selvas tropicales que favorecen el ecoturismo y la recreación natural. Sus ecosistemas permiten la observación de fauna silvestre.',
    population: '36,316 habitantes',
    area: '3,014.8 km²',
    foundation: '1876',
    attractions: 'Playas como Peñitas, Chalacatepec y El Coco, junto con la presa Cajón de Peña, conforman un entorno natural propicio para la observación de aves, recorridos por manglares y actividades de liberación de tortugas, La gastronomía local y el turismo natural.',
    color: 'from-green-500 to-emerald-600',
    EcologicaZona: 'Sitios RAMSAR Estero El Chorro, Estero Majahuas, Laguna de Chalacatepec, Laguna Xola-Paramán y Área Natural Protegida Santuario Playa Mismaloya.',
    administrativeRegion: 'Costa Sur',
    NumerodeUgas: '87'
  },
  {
    id: 3,
    name: 'La Huerta',
    shield: 'images/la_huerta-escudo.png',
    description: 'Dedicado a la agricultura, ganadería y pesca, el municipio se desarrolla en valles y áreas costeras con ríos y selvas tropicales. Su entorno natural permite el turismo rural y de naturaleza.',
    population: '23,258 habitantes',
    area: '2,325.8 km²',
    foundation: '1946',
    attractions: 'Playas como Chamela, Punta Pérula, Careyes y Cuixmala, junto con selvas y áreas de conservación, conforman paisajes ideales para el senderismo y la observación de fauna. Destacan también los proyectos comunitarios y talleres ambientales, así como la gastronomía regional.',
    color: 'from-amber-500 to-orange-600',
    EcologicaZona: 'Sitios RAMSAR Estero La Mazanilla, Laguna de Chalacatepec, Área Natural Protegida Reserva de la Biosfera Chamela Cuixmala, Santuario Islas la Pajarera, Cocinas, Mamut, Colorada, San Pedro, San Agustín, San Andrés, y Negrita, Santuario Playa Cuitzmala, Santuario Playa Mismaloya, Santuario Playa Teopa y Santuario Playa El Tecuán.',
    administrativeRegion: 'Costa Sur',
    NumerodeUgas: '50'
  },
  {
    id: 4,
    name: 'Cihuatlán',
    shield: 'images/cihuatlan-escudo.png',
    description: 'Con agricultura, pesca y actividades turísticas en comunidades costeras como manglares, esteros y playas aptas para el ecoturismo. Su territorio favorece la conservación de la biodiversidad local.',
    population: '40,139 habitantes',
    area: '501.3 km²',
    foundation: '1867',
    attractions: 'Playas como Barra de Navidad, Melaque y La Manzanilla, junto con sus manglares y esteros, ofrecen escenarios ideales para kayak, observación de aves y recorridos ecoturísticos. La pesca artesanal y la gastronomía costera.',
    color: 'from-purple-500 to-indigo-600',
    EcologicaZona: 'Sitio RAMSAR Laguna Barra de Navidad.',
    administrativeRegion: 'Costa Sur',
    NumerodeUgas: '19'
  }
];

const CostalegrePage = () => {
  const [selectedMunicipality, setSelectedMunicipality] = useState(municipalities[0]);

  const aboutLinks = [
    
    { text: 'Programa de Ordenamiento Ecológico y Territorial Regional', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20y%20Territorial%20Regi%C3%B3n%20Costalegre.pdf' },
    { text: 'Plan Regional de Integración Urbana', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Pubicacion/Plan_Regional_de_Integracion_Urbana.pdf' },
    { text: 'Programas Municipales de Desarrollo Urbano (Ver en Inicio)', url: '/descargas/costalegre' },
    
  ];

  const aboutDates = [
    { label: 'Inicio de proceso de formulación', date: '04/05/2019' },
    { label: 'Inicio de Consulta Pública', date: '21/05/2020' },
    { label: 'Fin de Consulta Pública', date: '09/10/2020' },
    { label: 'Sesión de validación', date: '27/04/2021' },
    { label: 'Fecha Publicación', date: '11/09/2021' },
  ];
  
  const bitacoraItems = [
    {
      title: 'FASE DE FORMULACIÓN',
      icon: FileSignature,
      color: 'from-blue-500 to-cyan-500',
      content: [
        {
          subtitle: 'Actas de Aprobación Municipal',
          items: [
            { text: 'Acta de Aprobación Cabo Corrientes', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/actasaprobacion/Acta_Apro_Cabo_Corrientes.pdf' },
            { text: 'Acta de Aprobación Cihuatlán', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/actasaprobacion/Acta_Apro_Cihuatlan.pdf' },
            { text: 'Acta de Aprobación La Huerta', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/actasaprobacion/Acta_Apro_La_Huerta.pdf' },
            { text: 'Acta de Aprobación Tomatlán', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/actasaprobacion/Acta_Apro_Tomatlan.pdf' },
            
          ]
        },
        {
          subtitle: 'Dictámenes y Oficios',
          items: [
            { text: 'Dictamen de Congruencia PMDU Cabo Corrientes', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Dictamen/Cabo_C._DEPOTGU_230_Dict._congr._PMDU.pdf' },
            { text: 'Dictamen de Congruencia PMDU Cihuatlán', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Dictamen/Cihuatlan_DEPOTGU_229_Dic._Congr._PMDU.pdf' },
            { text: 'Dictamen de Congruencia PMDU La Huerta', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Dictamen/La_Huerta_DEPOTGU_232_Dic._Congr._PMDU.pdf' },
            { text: 'Dictamen de Congruencia PMDU Tomatlán', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Dictamen/Tomatlan_DEPOTGU_231_Dic._Congr._PMDU.pdf' },
            { text: 'Oficio CONANP', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Dictamen/Oficio_CONANP_No._F00._DROPC._0784_2021.pdf' },
            { text: 'Oficio SEDATU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Dictamen/Oficio_SEDATU_No._SOTA.0366.2021.pdf' }
          ]
        },
        {
          subtitle: 'Convenios y Actas del Consejo',
          items: [
            { text: 'Convenio de Coordinación Estado-Municipios "Región Costalegre"', url: 'https://siga.jalisco.gob.mx/ordenamientos/actualizacion/Convenio_Coordinaci%C3%B3n_Estado_Municipios_Costalegre.pdf' },
            { text: 'Convenio Marco de Coordinación Estado – Federación', url: 'https://siga.jalisco.gob.mx/ordenamientos/actualizacion/ConvenioMarcoEstado_Federacion.pdf' },
            { text: 'Convenio Específico de Coordinación Estado- Federación Región “Región Costalegre”', url: 'https://siga.jalisco.gob.mx/ordenamientos/actualizacion/Convenio_Especifico_Region_Costalegre.pdf' },
            { text: 'Acta de Instalación y Primera Ordinaria CA 2020', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/Consejo/01_ACTA_DE_INSTALACION_Y_PRIMERA_ORDINARIA_2020.pdf' },
            { text: 'Acta de la primera extraordinaria CA 2020', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/Consejo/02_ACTA_DE_LA_PRIMERA_SESION_EXTRAORDINARIA_2020.pdf' },
            { text: 'Acta de la primera Ordinaria CA 2021', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/Consejo/03_ACTA_DE_LA_PRIMERA_SESION_ORDINARIA_2021_Costalegre.pdf' }
          ]
        }
      ]
    },
    {
      title: 'FASE DE EXPEDICIÓN',
      icon: FileSpreadsheet,
      color: 'from-emerald-500 to-green-500',
      content: [
        {
          subtitle: 'Consulta Pública',
          items: [
            { text: 'Documento puesto en Consulta Pública', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/EJECUTIVO_CA_Tabloide_Puesto_en_Consulta_Pública.pdf' },
            { text: 'Respuestas Consulta Pública Costalegre', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/RespuestasCostalegre.pdf' },
            { text: 'Publicación Periódico del Estado Región Costalegre', url: 'https://periodicooficial.jalisco.gob.mx/sites/periodicooficial.jalisco.gob.mx/files/09-11-2i-vi.pdf' }
          ]
        }
      ]
    },
    {
      title: 'FASE DE EJECUCIÓN',
      icon: Zap,
      color: 'from-amber-500 to-orange-500',
      content: [
        {
          subtitle: 'Monitoreo',
          items: [
            { text: 'Reforma a ordenamiento', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/Reforma_POEyTR_Costalegre.pdf' },
            { text: 'Boleta Registral', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/costalegre/05_RPPC_de_la_Region_Costalegre.zip' }
          ]
        }
      ]
    },
    {
      title: 'FASE DE EVALUACIÓN',
      icon: BarChart3,
      color: 'from-purple-500 to-violet-500',
      content: [
        {
          subtitle: 'Evaluaciones',
          items: [
            { text: 'Estudios Técnicos', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Evaluacion/EstudiosTecnicos.zip' },
            { text: 'Informes de Evaluación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Costalegre/Evaluacion/Informes_de_Evalucion.zip' }
          ]
        }
      ]
    }
  ];
  return (
    <div className="environmental-theme fade-in">
      <ModernBanner onScrollClick={scrollToSection} />
<section className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800" id="introduccion">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-white to-slate-100 dark:from-slate-900 dark:to-slate-800 rounded-3xl p-8 shadow-xl border border-slate-200 dark:border-slate-700"
          >
            <div className="flex flex-col lg:flex-row items-start gap-8">
              <div className="lg:w-2/3">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2 bg-gradient-to-r from-cyan-500 to-emerald-500 rounded-lg">
                    <Info className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
                      Ordenamiento Territorial Región Costalegre
                      <span className="block text-lg text-slate-600 dark:text-slate-300 mt-1">
                        Un proceso de planeación regional para conservar los recursos naturales y proteger el litoral.
                      </span>
                    </h2>
                  </div>
                </div>

                <div className="space-y-4 text-slate-700 dark:text-slate-300">
                  <p>
                    El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región Costalegre, integrada por los municipios de Cabo Corrientes, Cihuatlán, La Huerta y Tomatlán.
                  </p>
                  <p>
                    El convenio de coordinación suscrito en mayo de 2019, junto con los acuerdos federales de enero de 2020, sentaron las bases para la formulación, consulta y publicación del ordenamiento territorial.
                  </p>
                  <p>
                    Este proceso incorporó participación ciudadana, soporte técnico y estrategias de conservación para dar seguimiento a la gestión ambiental de la región costera.
                  </p>
                </div>

                <div className="mt-8 flex flex-wrap gap-3">
                  {aboutLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.url}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-2 rounded-full bg-slate-900 text-white px-5 py-3 text-sm font-medium shadow-lg hover:bg-slate-700 transition"
                    >
                      <ExternalLink className="w-4 h-4" />
                      {link.text}
                    </a>
                  ))}
                </div>
              </div>

              <div className="lg:w-1/3">
                <div className="bg-white dark:bg-slate-900 rounded-3xl p-6 shadow-lg border border-slate-200 dark:border-slate-700">
                  <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4 flex items-center">
                    <Calendar className="w-5 h-5 text-blue-500 mr-2" />
                    Cronología Clave
                  </h3>
                  <ul className="space-y-3 text-slate-700 dark:text-slate-300">
                    {aboutDates.map((date, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <span className="mt-1 w-2 h-2 rounded-full bg-emerald-500" />
                        <div>
                          <p className="font-semibold">{date.label}</p>
                          <p className="text-sm text-slate-500 dark:text-slate-400">{date.date}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section id="DocumentosE" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
        <DocumentRepository2
          items={CostalegreMain}
          onDownload={(doc) => window.open(doc.url, '_blank')}
          showFooter={false}
        />
      </section>

      <section id="Descargas" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
     <Descargas dataItems={items} />
     </section>



    
               <section className="municipalities-section py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-teal-50 to-cyan-100 dark:from-gray-900 dark:to-gray-800 min-h-screen font-sans">
      <div className="container mx-auto max-w-7xl">
        
        {/* --- Título Principal --- */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-teal-800 dark:text-teal-400 text-center mb-16 relative">
          <MapPin className="inline-block mr-3 mb-1 w-10 h-10" />
          Municipios de la Región : Costalegre
          <p className="text-lg font-normal text-gray-600 dark:text-gray-400 mt-2">
            Conoce los municipios y sus características clave.
          </p>
        </h2>
        
        {/* --- Grid de Tarjetas (Selector) --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {municipalities.map((municipality) => (
            <div 
              key={municipality.id}
              onClick={() => setSelectedMunicipality(municipality)}
              className={`
                municipality-card 
                rounded-2xl 
                overflow-hidden 
                shadow-xl 
                transition-all 
                duration-500 
                cursor-pointer 
                hover:shadow-2xl 
                hover:scale-[1.03]
                bg-white/90 dark:bg-gray-800/80
                backdrop-blur-sm
                border border-gray-100 dark:border-gray-700
                ${selectedMunicipality.id === municipality.id 
                  ? 'ring-4 ring-teal-500 scale-[1.03] shadow-teal-300/50 dark:shadow-teal-700/50' 
                  : 'hover:ring-2 hover:ring-teal-300'
                }
              `}
            >
              <div className={`h-28 ${municipality.color} flex flex-col items-center justify-center p-3 text-white font-bold`}>
                <img 
                  src={municipality.shield} 
                  alt={`Escudo de ${municipality.name}`} 
                  className="h-14 w-14 object-contain mb-1 drop-shadow-md"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x64/000000/ffffff?text=E"; }}
                />
              </div>
              <div className="p-4">
                <h3 className="text-xl font-extrabold text-center text-gray-900 dark:text-white">{municipality.name}</h3>
                <p className="text-xs text-center text-teal-600 dark:text-teal-400 mt-1 flex items-center justify-center">
                    Ver Detalles <ChevronRight className='w-3 h-3 ml-1'/>
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* --- Detalles del municipio seleccionado (Modern Panel) --- */}
        <div 
            key={selectedMunicipality.id} // Key para forzar la animación en cada selección
            className="municipality-details bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 max-w-6xl mx-auto border border-teal-200 dark:border-teal-900 animate-fade-in-up"
            style={{ '--delay': '200ms' }}
        >
          <div className="flex flex-col md:flex-row items-start gap-10">
            
            {/* Escudo y Descripción */}
            <div className="w-full md:w-1/3 flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl">
              <img 
                src={selectedMunicipality.shield} 
                alt={`Escudo de ${selectedMunicipality.name}`} 
                className="h-48 w-48 object-contain shadow-lg rounded-full p-2 bg-white dark:bg-gray-900 mb-6 border-4 border-teal-300 dark:border-teal-500"
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/192x192/000000/ffffff?text=E"; }}
              />
              <h3 className="text-3xl font-bold mb-2 text-gray-900 dark:text-white text-center">{selectedMunicipality.name}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm text-center italic mt-2">{selectedMunicipality.description}</p>
            </div>
            
            {/* Información Detallada (Badges) */}
            <div className="w-full md:w-2/3">
                
                <h4 className="text-2xl font-bold text-teal-700 dark:text-teal-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-2 flex items-center">
                    <Info className='w-5 h-5 mr-2'/> Datos Clave
                </h4>

                {/* Grid de Métricas */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <DetailBadge icon={Users} label="Población" value={selectedMunicipality.population} />
                    <DetailBadge icon={Map} label="Superficie" value={selectedMunicipality.area} />
                    <DetailBadge icon={Calendar} label="Municipalización" value={selectedMunicipality.foundation} />
                    <DetailBadge icon={Landmark} label="Región Administrativa" value={selectedMunicipality.administrativeRegion} />
                    <DetailBadge icon={MapPin} label="Número de UGAs" value={selectedMunicipality.NumerodeUgas} />
                    <DetailBadge icon={MountainSnow} label="Zonas de Importancia Ecológica" value={selectedMunicipality.EcologicaZona} />
                </div>
                
                {/* Atracciones (Full Width) */}
                <div className="mt-8 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-3 flex items-center">
                        <Waves className='text-blue-500 mr-2 w-5 h-5'/> Principales Atracciones
                    </h4>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:border-blue-800">
                        {selectedMunicipality.attractions}
                    </p>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
     
      <FullWidthVisorWithSidebar />
      <ModernBitacoraSection items={bitacoraItems} />
      <FasesSection 
        imageUrl="images/FasesOrdenamiento.png"
        altText="Fases del Ordenamiento Costalegre"
      />
    </div>
  );
};

export default CostalegrePage;